import {MantineSize} from '@mantine/core'

export const DefaultSizes: Record<MantineSize, number> = {
  xs: 24,
  sm: 36,
  md: 40,
  lg: 48,
  xl: 56,
}
